module.exports = __webpack_public_path__ + "static/media/logo192-dakko.bf9b07e1.png";